import { Link, Stack } from '@mui/material'
import getEnv from '@src/utils/envUtils'
import React from 'react'
import BrandImage from './BrandImage'

const Header = (): JSX.Element => {
  const { frontPageUrl, logoText } = getEnv()

  return (
    <Stack
      sx={{ borderBottom: '1px solid', borderColor: 'grey.400', py: 1, px: 2 }}
      direction={'row'}
      alignItems={'center'}
      gap={2}
      role={'banner'}
    >
      <Link
        href={frontPageUrl}
        sx={{
          '&.Mui-focusVisible': {
            outline: '5px solid #192d6a',
          },
        }}
      >
        <BrandImage imageBaseName="logo" altText={logoText} />
      </Link>
    </Stack>
  )
}

export default Header
